const cookieConsent = `{
    getCookieConsentGroups {
        group_id
        tab_title
        tab_description
        default_status
    }
}`;

export default {
    cookieConsent,
};